export const getPrice = (price: number) => {
  let result = price.toFixed(2);
  const maxPrecision = price.toString().length;
  let precision = 3;
  while (price !== 0 && result.replaceAll('0', '').length < 3 /* === '.' */ && precision <= maxPrecision) {
    result = price.toFixed(precision);
    precision ++;
  }
  return result;
};